import React, { Component } from "react";
import remove from "lodash/remove";

let userWishlistProgrammeIds = [];

function withUserWishlistProgrammeIds() {
  return function wrapWithUserWishlistProgrammeIds(WrappedFormComponent) {
    class WithUserWishlistProgrammeIds extends Component {
      userWishlistProgrammeIds = userWishlistProgrammeIds; // on récupère la valeur qui est sauvegardé lors du initializeWishlistProgrammeIds()

      initializeWishlistProgrammeIds = (programmeIds = []) => {
        userWishlistProgrammeIds = programmeIds; // on sauvegarde la valeur pour la partager avec les autres classes qui utilisent ce HOC
        this.userWishlistProgrammeIds = programmeIds;
      };

      addToWishlist = (programmeId) => {
        this.userWishlistProgrammeIds.push(programmeId);
      };

      removeFromWishlist = (programmeId) => {
        remove(this.userWishlistProgrammeIds, (id) => id === programmeId);
      };

      isInWishlist = (programmeId) => {
        return this.userWishlistProgrammeIds.includes(programmeId);
      };

      render() {
        return (
          <WrappedFormComponent
            {...this.props}
            initializeWishlistProgrammeIds={this.initializeWishlistProgrammeIds}
            addToWishlist={this.addToWishlist}
            removeFromWishlist={this.removeFromWishlist}
            isInWishlist={this.isInWishlist}
          />
        );
      }
    }

    return WithUserWishlistProgrammeIds;
  };
}

export default withUserWishlistProgrammeIds;
